import React from 'react';
export function Footer() {
  return <footer className="py-6 sm:py-10 px-4 border-t border-brand-sage/30 bg-brand-cream text-center text-brand-text-muted text-xs sm:text-sm font-medium" data-id="element-62">
      <div className="max-w-xl mx-auto space-y-3" data-id="element-63">
        <p className="text-brand-olive font-bold uppercase tracking-wider" data-id="element-64">
          RESET MEDITERRANEO™ 2026
        </p>
        <p className="leading-relaxed" data-id="element-65">
          Il sistema più completo in Italia per sgonfiare l'addome e ritrovare
          energia.
        </p>
        <p className="text-[10px] sm:text-xs text-brand-text-muted/70 mt-6" data-id="element-66">
          © RESET MEDITERRANEO™ 2026 — Tutti i diritti riservati.
        </p>
      </div>
    </footer>;
}